module.exports = {
      id: "text-usage",
      viewBox: "0 0 18.361 15.287",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#text",
      toString: function () {
        return this.url;
      }
    }